var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show && _vm.backUrl)?_c('section',{class:['outcode-backbtn', _vm.backBtnClass]},[_c('span',{staticClass:"btn-back",on:{"click":_vm.back}}),_c('span',{staticClass:"hide",on:{"click":_vm.hide}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }